(function () {
  function init(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var variants = JSON.parse(el.parentElement.querySelector('[data-backorder-variants]').textContent);
    var form = document.getElementById('product-form-' + el.dataset.sectionId);
    var root = el.closest('product-info') || document;

    function update() {
      var idInput = form && form.querySelector('input[name="id"]');
      var qtyInput = root.querySelector('input[name="quantity"]');
      var v = idInput && variants[idInput.value];
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!v || !v.on) { el.hidden = true; return; }
      var stock = Math.max(v.stock, 0);
      if (qty <= stock) { el.hidden = true; return; }
      var template = stock === 0
        ? el.dataset.textAll
        : stock === 1
          ? el.dataset.textPartialOne
          : el.dataset.textPartial;
      el.textContent = template.replace('[[stock]]', stock).replace('[[backorder]]', qty - stock);
      el.hidden = false;
    }

    root.addEventListener('change', update);
    root.addEventListener('input', update);
    update();
  }
  document.querySelectorAll('[data-backorder-notice]').forEach(init);
})();
